import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * PointProductsApi - axios parameter creator
 * @export
 */
const PointProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary The products\' points: by default the current value of each product or variant (and one scheduled to replace it), with history every row. Sort and filter take the grid\'s field names (pname, pcode, bcd, pnt, afrom, ato, crt) or the product paths the grids used to send. It used to list every historical row, remap only the sort (so filtering by a field name failed; unknown fields are now dropped), never match the barcode, load the whole Product and ProductDimension tables on every page, and show the request time as the row\'s date. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {boolean} [history]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (loadOptions, history, options = {}) => {
            const localVarPath = `/v1/PointProducts/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (history !== undefined) {
                localVarQueryParameter['history'] = history;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PointProductsApi - functional programming interface
 * @export
 */
const PointProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PointProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary The products\' points: by default the current value of each product or variant (and one scheduled to replace it), with history every row. Sort and filter take the grid\'s field names (pname, pcode, bcd, pnt, afrom, ato, crt) or the product paths the grids used to send. It used to list every historical row, remap only the sort (so filtering by a field name failed; unknown fields are now dropped), never match the barcode, load the whole Product and ProductDimension tables on every page, and show the request time as the row\'s date. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {boolean} [history]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(loadOptions, history, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(loadOptions, history, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointProductsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PointProductsApi - factory interface
 * @export
 */
const PointProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PointProductsApiFp(configuration);
    return {
        /**
         *
         * @summary The products\' points: by default the current value of each product or variant (and one scheduled to replace it), with history every row. Sort and filter take the grid\'s field names (pname, pcode, bcd, pnt, afrom, ato, crt) or the product paths the grids used to send. It used to list every historical row, remap only the sort (so filtering by a field name failed; unknown fields are now dropped), never match the barcode, load the whole Product and ProductDimension tables on every page, and show the request time as the row\'s date. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {boolean} [history]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(loadOptions, history, options) {
            return localVarFp.getAll(loadOptions, history, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PointProductsApi - object-oriented interface
 * @export
 * @class PointProductsApi
 * @extends {BaseAPI}
 */
class PointProductsApi extends BaseAPI {
    /**
     *
     * @summary The products\' points: by default the current value of each product or variant (and one scheduled to replace it), with history every row. Sort and filter take the grid\'s field names (pname, pcode, bcd, pnt, afrom, ato, crt) or the product paths the grids used to send. It used to list every historical row, remap only the sort (so filtering by a field name failed; unknown fields are now dropped), never match the barcode, load the whole Product and ProductDimension tables on every page, and show the request time as the row\'s date. (Auth roles: System)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {boolean} [history]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointProductsApi
     */
    getAll(loadOptions, history, options) {
        return PointProductsApiFp(this.configuration).getAll(loadOptions, history, options).then((request) => request(this.axios, this.basePath));
    }
}

export { PointProductsApi, PointProductsApiAxiosParamCreator, PointProductsApiFactory, PointProductsApiFp };
//# sourceMappingURL=point-products-api.js.map
